import { render, staticRenderFns } from "./DealAnalysis.vue?vue&type=template&id=06a63409&scoped=true"
import script from "./DealAnalysis.vue?vue&type=script&lang=js"
export * from "./DealAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a63409",
  null
  
)

export default component.exports